<template>
  <highcharts
    ref="highchart"
    class="stock"
    :constructor-type="'stockChart'"
    :options="chartOptions"
  ></highcharts>
</template>
<script>
export default {
  data() {
    return {
      bootstrapped: false,
      initialSenderStats: [],
      initialReceiverStats: [],
      lastSenderStat: 0,
      lastReceiverStat: 0,
      chartOptions: {
        time: {
          useUTC: true
        },
        rangeSelector: {
          verticalAlign: "bottom",
          buttons: [
            {
              count: 1,
              type: "minute",
              text: "1M"
            },
            {
              count: 5,
              type: "minute",
              text: "5M"
            },
            {
              type: "all",
              text: "All"
            }
          ],
          inputEnabled: false,
          selected: 0
        },
        credits: {
          enabled: false // Do not show the credits label which defaults to say "Highcharts".
        }
      }
    };
  },
  props: {
    metadata: null
  },
  mounted() {
    var me = this;
    this.$refs.highchart.chart.showLoading();
    this.$refs.highchart.chart.setTitle({
      text: me.metadata.title
    });
    this.$refs.highchart.chart.yAxis[0].setTitle({
      text: me.metadata.unit
    });
  },
  methods: {
    initSeries: function(name, colour, data) {
      this.$refs.highchart.chart.addSeries({
        name: name,
        showInLegend: false,
        color: colour,
        data: (function() {
          /*
            Generate five minutes of zero'ed out data as a starting baseline if necessary.
            This seems to be necessary and I'm unsure why... but without it
            the `series[0].addPoint` function silently fails to add points.

            Note: we assume a 10s step size between data points here, so 30 points
            means we have 5m of data and do not need to pad.
          */
          const second = 1000;
          const stepSize = 10 * second; // 10s.
          const padLength = 30; // padLength * stepSize * second = 5m.
          if (data.length >= padLength) {
            return data;
          }

          // If we have a starting data point then we use its time value and pad with 5m of zeroes wrt that time.
          // If not then we just use now ... unlikely given that we are always looking at either live
          // connections or historical connections.
          var time = data.length
            ? new Date(data[0][0]).getTime()
            : new Date().getTime();

          for (var i = 1; i < padLength; i++) {
            var x = time - i * stepSize;
            data.unshift([x, 0]);
          }
          return data;
        })()
      });
    },
    bootstrap: function() {
      // Hide loading before initializing the series (rather than after),
      // provides a better look at the chart animation as the series populates.
      this.$refs.highchart.chart.hideLoading();

      /* Colour values from spec (https://docs.google.com/document/d/1DJHG2GCEgBsUeMjC3CeutAHks-Rw7JZKmWTJMgRmISk/edit?ts=5cd476de#) */
      var name = "receiver";
      var colour = "#36DDD1"; /* Light blue (receiver). */
      var data = this.initialReceiverStats;
      if (this.metadata.senderOnly) {
        name = "sender";
        colour = "#B5DD26"; /* Light green (sender). */
        data = this.initialSenderStats;
      }
      this.initSeries(name, colour, data);

      // We add a second series if this chart is for send/receive ... this series will be for the sender.
      if (!this.metadata.senderOnly && !this.metadata.receiverOnly) {
        this.initSeries(
          "sender",
          "#B5DD26" /* Light green (sender). */,
          this.initialSenderStats
        );
      }

      this.bootstrapped = true;
    },
    addPoint: function(type, x, y, redraw) {
      // Coalesce this new stat with our last stat (new value is either a number or null).
      if (type === "sender") {
        this.lastSenderStat = y == null ? this.lastSenderStat : y;
        y = this.lastSenderStat;
      } else {
        this.lastReceiverStat = y == null ? this.lastReceiverStat : y;
        y = this.lastReceiverStat;
      }

      if (!this.bootstrapped) {
        /*
        Add a point to this component's initila data set(s) in preparation for bootstrapping the chart.
        */
        if (type === "sender") {
          this.initialSenderStats.push([x, y]);
        } else {
          this.initialReceiverStats.push([x, y]);
        }
      } else {
        /*
        Add a point to the chart instance's series.
        Note that `redraw` and `shift` are important to keep the rolling data window working as points are added.
        */
        var seriesIndex = this.$refs.highchart.chart.series.findIndex(s => {
          return s.name === type;
        });

        this.$refs.highchart.chart.series[seriesIndex].addPoint(
          [x, y],
          redraw /* redraw */,
          redraw /* shift */
        );
      }
    }
  }
};
</script>
<style scoped>
.stock {
  width: 90%;
  margin: 0 auto;
}
</style>
